import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';

export const useEnableManagerProgression = () => {
  const {
    flags: { managerProgressionSports },
  } = useFeatureFlags();
  return !!managerProgressionSports?.includes('nba');
};
